// @flow
import React, { type Node, useMemo } from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import PlainButton from 'app/common/ui-next/plain-button';
import PlainIcon, { iconTypes, colorTypes } from 'app/common/ui-next/plain-icon';
import { toFixedValueCurrency } from 'app/common/lib/toFixedValue';
import { useCurrencySign } from 'app/common/components-next/currency';

import styles from './ExchangeModalFooter.module.scss';;


type Props = {
  className?: string,
  orderTotal?: number,
  disabled?: boolean,
  loading?: boolean,
  sending: boolean,
  onOrderSubmit: (e: SyntheticEvent<HTMLElement>) => Promise<void>,
  onCancel: () => void,
  children: Node,
}

const ExchangeModalFooter = ({
  className,
  orderTotal,
  disabled,
  loading,
  sending,
  onOrderSubmit,
  onCancel,
  children,
}: Props): Node => {
  const { t } = useTranslation('cafeteria');
  const currency = useCurrencySign();

  const totalString = useMemo(() => (
    `${t('order_form_total', 'Итого')} ${toFixedValueCurrency(orderTotal, false, currency)}`
  ), [orderTotal, t, currency]);

  return (
    <div className={cn(styles.root, className)}>
      <PlainButton outline onClick={onCancel}>
        {t('order_request_sales_exchange_complex_form_close', 'Закрыть')}
      </PlainButton>

      <div className={styles.space} />

      {children}

      <div className={styles.total}>
        {totalString}
      </div>

      <PlainButton
        disabled={disabled || sending || loading}
        onClick={onOrderSubmit}
      >
        {sending
          ? t('order_request_sales_exchange_complex_form_confirm_pending', 'Подтверждение...')
          : t('order_request_sales_exchange_complex_form_confirm', 'Подтвердить')}
        &nbsp;
        <PlainIcon
          type={iconTypes.CHECKED}
          colorType={colorTypes.COLOR_WHITE}
        />
      </PlainButton>

    </div>
  );
};

export default ExchangeModalFooter;
